var chatarea = {

    _resizeBound: false,
    _replyId: "reply-textarea",

    init: () => {
        chatarea.bindReply();

        const header = helper.element("header");
        const input = helper.element(".message-area-input");
        const area = helper.element(".message-area");
        const content = helper.element(".message-area-content");
        const notesbar = helper.element(".notes-bar");
        const notesflyover = helper.element(".notes-flyover");

        if (area && content && header && input && notesbar && notesflyover && area.length !== 0 && content.length !== 0 && header.length !== 0 && input.length !== 0 && notesbar.length !== 0 && notesflyover.length !== 0) {
            chatarea.resize(header, input, area, content, notesbar, notesflyover);

            // init runs on every incoming message - only bind the resize listener once
            // per page load, otherwise duplicates pile up and each resize does more and more work.
            if (!chatarea._resizeBound) {
                chatarea._resizeBound = true;
                helper.event(window, "resize", () => {
                    chatarea.resize(header, input, area, content, notesbar, notesflyover);
                });
            }
        }

    },

    // NOTE: deliberately getElementById and not helper.element() - helper.element() routes every
    // "."-prefixed string to getElementsByClassName(), which reads a descendant selector like
    // ".foo textarea" as "has BOTH classes foo and textarea", matches nothing, and returns an
    // empty HTMLCollection that is still truthy.
    reply: () => document.getElementById(chatarea._replyId),

    // The reply box is uncontrolled (Blazor never renders its value), so these are the only way
    // the server can write to it - see the comment on OnSendMessageInput in ChatArea.razor.
    setReplyText: (text) => {
        const textarea = chatarea.reply();
        if (textarea) {
            textarea.value = text == null ? "" : text;
        }
    },

    getReplyText: () => {
        const textarea = chatarea.reply();
        return textarea ? textarea.value : "";
    },

    bindReply: () => {
        const textarea = chatarea.reply();
        if (!textarea || textarea.dataset.enterBound === "1") {
            return;
        }
        textarea.dataset.enterBound = "1";

        // Enter (without shift) sends. Blazor handles the keydown server-side, so without this the
        // browser still inserts the newline locally - it would land in the box after the send has
        // already cleared it, and get carried into the next message.
        textarea.addEventListener("keydown", (e) => {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
            }
        }, false);
    },

    resize: (header, input, area, content, notesbar, notesflyover) => {
        const getOuterHeight = (el) => {
            if (el) {
                try {
                    const style = window.getComputedStyle(el);
                    const margin = parseFloat(style.marginTop || 0) + parseFloat(style.marginBottom || 0);
                    const padding = parseFloat(style.paddingTop || 0) + parseFloat(style.paddingBottom || 0);
                    return el.offsetHeight + margin + padding;
                } catch (e) {
                    console.error("Error calculating outer height:", e);
                    return el.offsetHeight; // Fallback to offsetHeight if there's an error
                }

            }
            return 0;
        };
        let headerHeight = getOuterHeight(header);
        let inputHeight = getOuterHeight(input);
        let notesbarHeight = getOuterHeight(notesbar);
        let totalHeight = window.innerHeight;
        let areaHeight = totalHeight - (headerHeight + inputHeight + notesbarHeight);
        //notesflyover.setAttribute("data-height", areaHeight + notesbarHeight + inputHeight);
        area.style.cssText = `height: calc(${areaHeight}px + 1rem) !important`;
        notesflyover.style.setProperty('--notes-height', areaHeight + notesbarHeight + inputHeight + 'px');
        

        // scroll down to bottom
        area.scrollTop = area.scrollHeight;

    }

}